module.exports = __webpack_public_path__ + "static/media/InconsolataBold.6fac461f.ttf";